import React from 'react';
import { CalendarDays } from 'lucide-react';
import { todayStr, addDays, dayLabel } from './routeDate';

// Dag-tabs om vooruit te plannen; badge = aantal ingeplande motoren op die dag.
export const PlanDayTabs = ({ value, onChange, plannedByDate }) => {
  const t = todayStr();
  const days = Array.from({ length: 7 }, (_, i) => addDays(t, i));
  const extra = Object.keys(plannedByDate).filter((d) => !days.includes(d) && d > t).sort();
  const custom = value && !days.includes(value) && !extra.includes(value) ? [value] : [];
  return (
    <div className="bg-white rounded-xl border-2 border-purple-200 p-3" data-testid="plan-day-tabs">
      <div className="flex items-center gap-2 text-sm font-semibold text-zinc-900 mb-2">
        <CalendarDays className="w-4 h-4 text-purple-600" /> Plannen voor:
        <span className="text-purple-700" data-testid="plan-day-current">
          {dayLabel(value)} {new Date(`${value}T12:00:00`).toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })}
        </span>
      </div>
      <div className="flex items-center gap-1.5 flex-wrap">
        {[...days, ...extra, ...custom].map((d) => {
          const n = plannedByDate[d] || 0;
          const active = value === d;
          return (
            <button key={d} onClick={() => onChange(d)} data-testid={`plan-day-${d}`}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors flex items-center gap-1.5 ${
                      active ? 'bg-purple-600 text-white' : 'bg-zinc-100 text-zinc-700 hover:bg-zinc-200'}`}>
              {dayLabel(d)}
              {n > 0 && (
                <span className={`text-[10px] font-bold px-1.5 rounded-full ${active ? 'bg-white text-purple-700' : 'bg-purple-600 text-white'}`}>{n}</span>
              )}
            </button>
          );
        })}
        <input type="date" min={t} value="" onChange={(e) => e.target.value && onChange(e.target.value)}
               title="Andere datum kiezen" className="text-sm px-2 py-1 rounded-lg border border-zinc-300"
               data-testid="plan-day-input" />
      </div>
    </div>
  );
};
